// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-warning[data-v-2e567752]{color:var(--error)}.remove-project-dialog[data-v-2e567752]{border:1px solid var(--border);padding:10px;border-radius:5px}.remove-project-dialog .display-name[data-v-2e567752]{font-weight:700}", ""]);
// Exports
module.exports = exports;
